<template>
  <login-layout class="view-password-restore">
    <v-overlay v-if="loading||formState.sending">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>
    <v-card-text class="text-center">
      <h1 class="mb-6">Password change</h1>
      <v-alert type="success" v-if="formState.success">
        Password has been changed successfully.
      </v-alert>
      <v-form @submit.prevent="submit" v-else>
        <v-alert type="error" v-if="formState.error.length">
          {{ formState.error }}
        </v-alert>
        <p>Please enter your new password.</p>

        <v-row>
          <v-col cols="12" sm="6">
            <v-text-field
              v-model="form.password"
              label="Password"
              name="password"
              prepend-icon="lock"
              :append-icon="formState.passwordMode ? 'visibility_off' : 'visibility'"
              @click:append="() => (formState.passwordMode = !formState.passwordMode)"
              :type="formState.passwordMode ? 'password' : 'text'"
              color="primary darken-4"
              :error="formState.validation && $v.form.password.$error"
              :error-messages="$v.form.password.$error ? passwordErrors($v) : ''"
            ></v-text-field>
          </v-col>
          <v-col cols="12" sm="6">
            <v-text-field
              v-model="form.repeatPassword"
              label="Repeat password"
              name="repeatPassword"
              prepend-icon="lock"
              :append-icon="formState.passwordMode ? 'visibility_off' : 'visibility'"
              @click:append="() => (formState.passwordMode = !formState.passwordMode)"
              :type="formState.passwordMode ? 'password' : 'text'"
              color="primary darken-4"
              :error="formState.validation && $v.form.repeatPassword.$error"
              :error-messages="$v.form.repeatPassword.$error ? passwordRepeatErrors($v) : ''"
            ></v-text-field>
          </v-col>
        </v-row>

        <v-btn large
               color="primary darken-4 white--text"
               :disabled="formState.sending"
               @click="submit">
          Reset password
        </v-btn>
      </v-form>
    </v-card-text>
    <v-row justify="center">
      <v-dialog v-model="error" persistent max-width="290">
        <v-card>
          <v-card-title class="headline">Error</v-card-title>
          <v-card-text>
            {{ errorMessage }}
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="black" text @click="error = false">OK</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-row>
  </login-layout>
</template>

<script>
    import { passwordValidators, passwordRepeatValidators, passwordErrorMessage, passwordRepeatErrorMessage } from '../helpers/passwordHelpers'

    export default {
        name: "PasswordRestore",

        validations: {
            form: {
                password: passwordValidators,
                repeatPassword: passwordRepeatValidators('form', 'password')
            }
        },

        computed: {
            loading () {
                return this.$store.state.loading
            }
        },

        data() {
            return {
                error: false,
                errorMessage: '',
                form: {
                    token: this.$route.params.token,
                    password: '',
                    repeatPassword: '',
                },
                formState: {
                    sending: false,
                    validation: false,
                    passwordMode: true,
                    error: '',
                    success: false,
                },
            };
        },

        mounted() {
            this.getData();
        },

        methods: {
            async getData() {
                this.$store.commit('loadingOn')

                await this.$sessionService.getPasswordRestore(this.$route.params.token).then(
                    (response)=> {
                        console.log(response)
                    }
                ).catch(
                    (error)=> {
                        this.error = true
                        this.errorMessage = error.response.data.error
                        setTimeout(()=>{this.$router.replace({ name: 'error' })}, 3000)
                    }
                );

                this.$store.commit('loadingOff')
            },

            passwordErrors($v) {
              return passwordErrorMessage($v.form.password)
            },

            passwordRepeatErrors($v) {
              return passwordRepeatErrorMessage($v.form.repeatPassword)
            },

            submit() {
                this.formState.validation = true;
                this.$v.form.$touch();

                if (this.$v.$invalid) {
                    this.formState.sending = false;
                } else {
                    this.formState.sending = true;
                    this.formState.error = '';

                    this.$sessionService.passwordChange(this.form)
                        .then(() => {
                            this.formState.success = true
                            setTimeout(()=>this.$router.replace({ name: 'login' }), 1500)
                        })
                        .catch((error) => {
                            this.formState.error = error.response.data.error;
                        }).finally(() => this.formState.sending = false);
                }
            }
        }
    }
</script>

<style>
.view-password-restore .v-messages__message {
  white-space: pre;
}
</style>
